import { CustomerType } from "types/props"
import { Action, ActionWithoutPayload, Message } from "types/redux"

import { BP_PATH, NUMBER_OF_SLOTS_AFTER_NOW, NUMBER_OF_SLOTS_BEFORE_NOW, PATH } from "../models"
import { Answer, DocumentNavigation, Question, Reply } from "../types"
import { SurveySnapshot } from "./surveyStorage"
import type { LatestAnamnesisCache } from "./latestAnamnesis"
import { SET_PREVENTION_REPORT } from "containers/Profile/services/constants"
import { CANCEL_SURVEY, CLEAR_RESTORED_DOC_SELECTION, CREATE_QUESTION, GET_ALL_DOCUMENT_REQUESTS, HYDRATE_SURVEY, INIT_SURVEY, JUMP_TO_QUESTION, NEXT_QUESTION, PREVIOUS_QUESTION, QUESTION_SLOTS, REMOVE_QUESTION, RESET_ANAMNESIS, RESET_SURVEY_QUESTION_REPLIES, RESET_SURVEY_REPLY, RESET_SURVEY_STORE, SET_CUSTOMER_TYPE, SET_QUESTION, SUBMIT_SURVEY_ERROR, SUBMIT_SURVEY_REQUEST, SUBMIT_SURVEY_SUCCESS, UNSET_QUESTION, SET_VITALS_ANSWERS, REPLACE_QUESTIONS, VITALS_COMPLETED, SEND_REPORT_TO_MT_CONSENT, REMOVE_FAMILY_DOCTOR, REMOVE_FROM_PATH, FETCH_LATEST_ANAMNESIS, SET_LATEST_ANAMNESIS, PREFILL_ANAMNESIS } from "./constants"

const actions = {
  replaceQuestions: (questions: Question[]): Action<Question[]> => ({
    type: REPLACE_QUESTIONS,
    payload: questions,
  }),
  setStepReplies: (payload: {
    replies: Reply[]
    id?: PATH | BP_PATH
  }): Action<{ replies: Reply[]; id?: PATH | BP_PATH }> => ({
    type: SET_QUESTION,
    payload,
  }),

  unsetStepReplies: (payload: {
    replies?: Reply[]
    id?: PATH
  }): Action<{ replies?: Reply[]; id?: PATH }> => ({
    type: UNSET_QUESTION,
    payload,
  }),
  set: (replies: Reply[]): Action<Reply[]> => ({
    type: SET_QUESTION,
    payload: replies,
  }),

  unset: (replies?: Reply[]): Action<Reply[] | undefined> => ({
    type: UNSET_QUESTION,
    payload: replies,
  }),
  reset: (): ActionWithoutPayload => ({ type: RESET_SURVEY_STORE }),
  resetReply: (id: string) => ({ type: RESET_SURVEY_REPLY, payload: id }),
  resetAnamnesis: (): ActionWithoutPayload => ({ type: RESET_ANAMNESIS }),
  fetchLatestAnamnesis: (): ActionWithoutPayload => ({
    type: FETCH_LATEST_ANAMNESIS,
  }),
  setLatestAnamnesis: (
    payload: LatestAnamnesisCache,
  ): Action<LatestAnamnesisCache> => ({
    type: SET_LATEST_ANAMNESIS,
    payload,
  }),
  prefillAnamnesis: (payload: Answer): Action<Answer> => ({
    type: PREFILL_ANAMNESIS,
    payload,
  }),
  hydrateSurvey: (snapshot: SurveySnapshot): Action<SurveySnapshot> => ({
    type: HYDRATE_SURVEY,
    payload: snapshot,
  }),
  clearRestoredDocSelection: (): ActionWithoutPayload => ({
    type: CLEAR_RESTORED_DOC_SELECTION,
  }),
  resetReplies: (): ActionWithoutPayload => ({
    type: RESET_SURVEY_QUESTION_REPLIES,
  }),
  init: (): ActionWithoutPayload => ({ type: INIT_SURVEY }),
  cancel: (): ActionWithoutPayload => ({ type: CANCEL_SURVEY }),
  next: (): ActionWithoutPayload => ({ type: NEXT_QUESTION }),

  previous: (): ActionWithoutPayload => ({ type: PREVIOUS_QUESTION }),

  jumpTo: (id: PATH): Action<PATH> => ({ type: JUMP_TO_QUESTION, payload: id }),

  setSlots: (): Action<{ slotsBeforeNow: number; slotsAfterNow: number }> => ({
    type: QUESTION_SLOTS,
    payload: {
      slotsBeforeNow: NUMBER_OF_SLOTS_BEFORE_NOW,
      slotsAfterNow: NUMBER_OF_SLOTS_AFTER_NOW,
    },
  }),
  create: (payload: {
    question: Question
    options?: { after?: PATH; before?: PATH }
  }): Action<{
    question: Question
    options?: { after?: PATH; before?: PATH }
  }> => ({
    type: CREATE_QUESTION,
    payload,
  }),

  remove: (payload: string): Action<string> => ({
    type: REMOVE_QUESTION,
    payload,
  }),
  removeFromPath: (payload: string): Action<string> => ({
    type: REMOVE_FROM_PATH,
    payload,
  }),
  for: (customerType: CustomerType): Action<CustomerType> => ({
    type: SET_CUSTOMER_TYPE,
    payload: customerType,
  }),
  success: (): ActionWithoutPayload => ({ type: SUBMIT_SURVEY_SUCCESS }),

  error: (e: string): Action<Message> => ({
    type: SUBMIT_SURVEY_ERROR,
    payload: { type: "error", text: e },
  }),

  submit: (answers: Answer[]): Action<Answer[]> => {
    return { type: SUBMIT_SURVEY_REQUEST, payload: answers }
  },

  getDocuments: (
    navigation?: DocumentNavigation,
  ): ActionWithoutPayload | Action<DocumentNavigation> => ({
    type: GET_ALL_DOCUMENT_REQUESTS,
    ...(navigation ? { payload: navigation } : {}),
  }),
  setVitalsAnswers: (): ActionWithoutPayload => ({
    type: SET_VITALS_ANSWERS,
  }),
  setPreventionReport: () => ({
    type: SET_PREVENTION_REPORT,
  }),
  vitalsCompleted: (payload?: { pendingVitalCreate: boolean }): Action<{ pendingVitalCreate: boolean } | undefined> => ({
    type: VITALS_COMPLETED,
    payload,
  }),
  sendReportToMTConsent: (consent: boolean) => ({
    type: SEND_REPORT_TO_MT_CONSENT,
    payload: { consent }
  }),
  removeFamilyDoctor: (payload: {
    onSuccess: () => void
    onError: () => void
  }): Action<{ onSuccess: () => void; onError: () => void }> => ({
    type: REMOVE_FAMILY_DOCTOR,
    payload,
  }),
  
}

export default actions
